export const defaultOtherCategoriesPageSize = 6;

export const defaultOtherCategoriesOptions = [
    defaultOtherCategoriesPageSize,
    defaultOtherCategoriesPageSize * 2,
    defaultOtherCategoriesPageSize * 3,
    defaultOtherCategoriesPageSize * 4,
];
